import queryString from 'query-string';
import { getAccessToken } from './auth';

export const getLinkToIfs = url =>
    `${url}?${queryString.stringify({
        fsc_access_token: getAccessToken(),
    })}`;
